import ProductRepository from "@astina/paloma-shop-common-ui/src/services/ProductRepository";
export const GtmMapper = {
    async fromCartItem(item) {
        const sku = item.itemNumber || item.sku;
        const category = await ProductRepository.getVariantMainCategory(sku)
            .catch(e => {
            console.error("Failed to load category for analytics", e);
            return null;
        });
        const baseUnit = await ProductRepository.getVariantBaseOrderingUnit(sku)
            .catch(e => {
            console.error("Failed to load base unit for analytics", e);
            return null;
        });
        return {
            item_id: sku,
            item_name: item.title,
            item_category: category?.name || "",
            item_category_id: category?.code || "",
            price: item.unitPricing.grossPrice,
            unit_of_measurement: baseUnit?.toString() || "",
            quantity: item.quantity
        };
    },
    async fromWatchlistItem(item) {
        const pricePromise = ProductRepository.getVariantPrice(item.sku, 1)
            .then(data => data?.price || "")
            .catch(e => {
            console.error("Failed to load price for analytics", e);
            return "";
        });
        const categoryPromise = ProductRepository.getVariantMainCategory(item.sku)
            .catch(e => {
            console.error("Failed to load category for analytics", e);
            return null;
        });
        const baseUnitPromise = ProductRepository.getVariantBaseOrderingUnit(item.sku)
            .catch(e => {
            console.error("Failed to load base unit for analytics", e);
            return null;
        });
        const [price, category, baseUnit] = await Promise.all([pricePromise, categoryPromise, baseUnitPromise]);
        return {
            item_id: item.variant?.itemNumber || item.sku,
            item_name: item.title,
            item_category: category?.name || "",
            item_category_id: category?.code || "",
            price: Number.parseFloat(price),
            unit_of_measurement: baseUnit?.toString() || "",
            quantity: item.quantity
        };
    },
    async fromGeneric(item) {
        let price = 0;
        if (typeof item.unitPrice === 'string')
            price = parseFloat(item.unitPrice);
        else if (item.unitPricing?.grossPrice)
            price = item.unitPricing.grossPrice;
        else if (item.price)
            price = Number(item.price);
        const sku = item.sku || item.itemNumber || item.item_id;
        const category = await ProductRepository.getVariantMainCategory(sku)
            .catch(e => {
            console.error("Failed to load category for analytics", e);
            return null;
        });
        const baseUnit = await ProductRepository.getVariantBaseOrderingUnit(sku)
            .catch(e => {
            console.error("Failed to load base unit for analytics", e);
            return null;
        });
        return {
            item_id: sku,
            item_name: item.name || item.title || item.item_name,
            item_category: category?.name || "",
            item_category_id: category?.code || "",
            price: price,
            unit_of_measurement: baseUnit?.toString() || "",
            quantity: Number(item.quantity)
        };
    }
};
